export default __webpack_public_path__ + "static/media/josh1.70e44007.png";